// Pushes the Umbraco Forms submission event to the dataLayer.
//
// Umbraco Forms can render its "thank you" markup via AJAX (no page reload), and
// a <script> injected that way does NOT execute — so an inline dataLayer push in
// Submitted.cshtml silently never fires. Instead, Submitted.cshtml renders a
// marker element and this module pushes the event when it appears, watching the
// DOM so it also catches AJAX submissions.
//
// Event name / payload key are kept as the existing GTM convention
// (contactformSubmit / formName) so no GTM changes are required.
(function () {
  function pushFormSubmit() {
    const el = document.querySelector('.js-umbraco-form-submit[data-dl-event]');
    if (!el || el.dataset.dlPushed === '1') return;

    el.dataset.dlPushed = '1';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: el.dataset.dlEvent,
      formName: el.dataset.formName,
      form_id: el.dataset.formId || el.dataset.formClientId,
      record_id: el.dataset.recordId,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pushFormSubmit);
  } else {
    pushFormSubmit();
  }

  // Catch AJAX submissions, where the success markup is injected after load.
  new MutationObserver(pushFormSubmit).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
